'use client';

import { useState, useEffect } from 'react';


interface Season {
  name: string;
  months: string;
  icon: string;
  color: string;
  recommendations: Array<{
    service: string;
    priority: 'High' | 'Medium' | 'Low';
    reason: string;
  }>;
}

interface SeasonalRecommendationsProps {
  seasons: Season[];
}

export default function SeasonalRecommendations({ seasons }: SeasonalRecommendationsProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentSeason, setCurrentSeason] = useState(0);

  useEffect(() => {
    setIsHydrated(true);
    const month = new Date().getMonth();
    if (month >= 2 && month <= 4) setCurrentSeason(0); // Spring
    else if (month >= 5 && month <= 7) setCurrentSeason(1); // Summer
    else if (month >= 8 && month <= 10) setCurrentSeason(2); // Fall
    else setCurrentSeason(3); // Winter
  }, []);

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'High':
        return 'text-error bg-error/10';
      case 'Medium':
        return 'text-warning bg-warning/10';
      case 'Low':
        return 'text-success bg-success/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg shadow-brand p-6">
        <div className="animate-pulse">
          <div className="h-8 bg-muted rounded w-1/3 mb-6"></div>
          <div className="space-y-4">
            <div className="h-24 bg-muted rounded"></div>
            <div className="h-24 bg-muted rounded"></div>
            <div className="h-24 bg-muted rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}